export const parseUnits = (units = []) => {
    const unitsMap = new Map();

    for (const unit of units) {
        if (!unit?.id) continue;

        if (!unitsMap.has(unit.typeId)) {
            unitsMap.set(unit.typeId, { typeId: unit.typeId, values: [] });
        }

        const unitData = {
            id: unit.id,
            name: unit.label,
        };

        unitsMap.get(unit.typeId)?.values.push(unitData);
    }

    return Array.from(unitsMap, ([name, value]) => value).sort((a, b) => a.typeId - b.typeId);
};

export const parseUnitsValues = (units = []) =>
    units.map(({ id, label, typeId }) => ({
        id,
        name: label,
        typeId,
    }));
